import LoginTopBanner from "../../layout/AuthLayout/authTopbanner";
import LoginBanner from "../../assests/new-images/login-banner.webp";
import { useCallback, useEffect, useState } from "react";
import AuthService from "../../services/auth.service";
import { Spin } from "antd";
import { store } from "../../store";
import { CONFIG } from "../../environment";
import FEATURE_CONFIG from "client/feature.config.json";
import { useTranslation } from "react-i18next";
import { SET_COUNTRY_CODES, SET_OTP_TIMER, SET_SESSION_TIMER } from "../../store/constants";
import BANK_LOGO from "client/assets/LOGO/BANK_LOGO.png";
import QRCOde from "../../assests/new-images/QR.png";
import BGSlide from "../../assests/new-images/BG_SLIDE.png";
import ExchangeIcon from "../../assests/new-images/exchange.svg";
import BranchIcon from "../../assests/new-images/branch.svg";
import EligibilityIcon from "../../assests/new-images/loan.svg";
import "./authLayout.css";
import { useNavigate } from "react-router";



export default function AuthLayout({ children, module, title }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    getQuickLinksData();
    getMetaData();
    getCountryCodes();
  }, []);

  const getQuickLinksData = useCallback(async (value = false) => {
    try {
      const response = await AuthService.getQuickLinks(value);
      if (response.status === 200) {
      }
    } catch (err) {}
  }, []);

  const getMetaData = useCallback(async () => {
    try {
      const response = await AuthService.getMetaDataDetails();
      if (response.status === 200) {
        const otpExpiry = response.data?.otpExpiry * 60 || CONFIG.OTP_TIMER;
        const sessionTimeOut =
          response.data?.sessionTimeout * 60000 || CONFIG.SESSION_TIME_OUT;
        store.dispatch({ type: SET_OTP_TIMER, payload: otpExpiry });
        store.dispatch({ type: SET_SESSION_TIMER, payload: sessionTimeOut });
      }
    } catch (err) {}
  }, []);

  const getCountryCodes = useCallback(async () => {
    try {
      const response = await AuthService.getCountryCodes();
      if (response.status === 200) {
        const countryCodes = response.data?.countryCodeList || [];
        store.dispatch({ type: SET_COUNTRY_CODES, payload: countryCodes });
      }
    } catch (err) {}
  }, []);

  return (
    <>
      <div className="auth-layout">
        <div className="container-section">
          {FEATURE_CONFIG.LOGIN_TOP_BANNER && (
            <LoginTopBanner module={module} title={title} />
          )}
          <div className="auth-render-section">
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 hide-xs">
                <div
                  className="auth-left-section text-center"
                  style={{ width: 494, margin: "0 auto" }}
                >
                  <div className="left-main-section mx-4">
                      <img
                      src={LoginBanner}
                      className="mb-2"
                      style={{ height: "60vh" }}
                    />
                    {/* <img src={BANK_LOGO} height={50} className="mb-3" />

                    <img src={QRCOde} height={210} />

                    <div className="mt-4">
                      <h4 
                      // onClick={() => getQuickLinksData(true)}
                      className="mb-4">
                        Scan QR Code to Login{" "}
                      </h4>
                      <p className="open-banking-p">
                        Open your phone banking app to log in instantly,{" "}
                        {CONFIG.BANK_NAME} banking app version 8.0.3 or higher
                        is required
                      </p>
                    </div> */}
                  </div>
                  <div>
                    <p className="mb-2">Additional Services</p>

                    <div className="additional-service-icons">
                      {FEATURE_CONFIG.LANDING_SCREEN.EXCHANGE_RATES && (
                        <span
                          onClick={() => {
                            if (
                              FEATURE_CONFIG.LANDING_SCREEN
                                .IS_EXCHANGE_RATES === "LINK"
                            ) {
                              window.open(
                                FEATURE_CONFIG.LANDING_SCREEN
                                  .EXCHANGE_RATES_LINK,
                                "_blank"
                              );
                            } else {
                              CONFIG.EXCHANGE_RATE_COMING_SOON  ? navigate("/exchange-rates-feature") : navigate("/exchange-rates");
                            }
                          }}
                        >
                          <img src={ExchangeIcon} height={25} />
                          <label className="mt-2">
                            {t("pages.landing.exchange", {
                              defaultValue: "Exchange Rates",
                            })}
                          </label>
                        </span>
                      )}
                      {FEATURE_CONFIG.LANDING_SCREEN.LOCATE_US && (
                        <span onClick={() => navigate("/locations")}>
                          <img src={BranchIcon} height={25} />
                          <label className="mt-2">
                            {t("pages.landing.locate_branch", {
                              defaultValue: "Locate Branch",
                            })}
                          </label>
                        </span>
                      )}
                      {FEATURE_CONFIG.LANDING_SCREEN.ELEGIBILITY && (
                        <span onClick={() => navigate("/loan-eligibility")}>
                          <img src={EligibilityIcon} height={25} />
                          <label className="mt-2">
                            {t("pages.landing.e?", {
                              defaultValue: "Eligibility",
                            })}
                          </label>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                <div className="auth-card-padding" style={{ padding: "10px 20px" }}>
                  {children}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
